import {
  Resolve,
  Error as ErrorIcon,
  InfoCircle,
  Alert
} from "@dreamhub/designsystem/icons";
import IconContainer from "@/components/ui/icon-container";

export const toastIcon = {
  success: (
    <IconContainer size="7" color="positive">
      <Resolve />
    </IconContainer>
  ),
  error: (
    <IconContainer size="7" color="error">
      <ErrorIcon />
    </IconContainer>
  ),
  info: (
    <IconContainer size="7" color="natural">
      <InfoCircle />
    </IconContainer>
  ),
  warning: (
    <IconContainer size="7" color="warning">
      <Alert />
    </IconContainer>
  )
};
